import { COMPANY_UID_INPUT_REGEX } from '@houzy/schemas/partner-cockpit/onboarding';

// The `CHE-` prefix is chrome, not input: it is shown as an adornment and stripped from whatever is stored.
export const uidDigits = (uid: string | null | undefined): string => uid?.replace(/^CHE-/i, '') ?? '';

export const isCompanyUidFormatInvalid = (uid: string): boolean => {
    const trimmed = uid.trim();
    return trimmed.length > 0 && !COMPANY_UID_INPUT_REGEX.test(trimmed);
};
